export default class BroadcastChannelService {
  constructor() {
    this.channel = new BroadcastChannel('pp_session_sync');
  }

  postMessage(message) {
    this.channel.postMessage(message);
  }

  registerMessageListener(callback) {
    this.channel.addEventListener('message', callback);
  }

  close() {
    this.channel.close();
  }
}
